import React from "react";
import img2 from "../../../../../../assets/images/AISummit/aicopilot1.jpg";
import CustomButton from "../../../../../../shared_components/CustomButton";
const JoinUsSection = () => {
    return (
        <section className="row mx-0 align-items-center justify-content-center my-5">
            <div className="col-12 col-md-10 px-0">
                <div className="row mx-0 d-flex align-items-center justify-content-center">
                    <div className="col-12 col-md-6">
                        <h1>Join India’s fastest growing tech community</h1>
                        <p>Datacode has hosted over 100 innovative events across online and offline formats. From beginner series to advanced masterclasses, hackathons to hands-on workshops, we create spaces where developers, students, and tech enthusiasts connect, learn, and build together.</p>
                        <div className="p-3">
                            <CustomButton>Explore</CustomButton>
                            <CustomButton className="bg-light text-dark border ml-4">Partner</CustomButton>
                        </div>
                    </div>
                    <div className="col-12 col-md-6">
                        <img
                            src={img2}
                            alt="Community Event"
                            className="img-fluid"
                        />
                    </div>
                </div>
            </div>
        </section>
    );
};

export default JoinUsSection;
